import { checkClaimsWeb } from "@eventr/common";
import { useHasFeature } from "hooks/useHasFeature";
import { navbarTranslation } from "i18n/translateHelpers";
import { useBoundStore } from "state/bound.store";
import { withFeaturePermission } from "../../../editItinerary/HOC/withFeaturePermission";
import { useRocketChatContext } from "../../../rocketchat/rocketChatProvider";
import { useActiveNavBar, useNavBarHidden } from "../navBar.store";
import { TAB_BY_ID } from "../tabs";
import { NavBarItem } from "./navBarItem";

export const ChatNavBarItem = () => {
  const chatEnabled = useBoundStore((s) => s.chatEnabled);

  if (!chatEnabled) return null;

  return <FeatureChatItem />;
};
const ChatItem = () => {
  const { selectedItineraryUnreadCount } = useRocketChatContext();

  const activeNavBar = useActiveNavBar();
  const navBarHidden = useNavBarHidden();
  const hasFeature = useHasFeature("Chat");
  const canSendMessage = checkClaimsWeb(["/"], ["sendMessage"]);

  return (
    <NavBarItem
      id="navbarItemChat"
      label={canSendMessage ? navbarTranslation(TAB_BY_ID.chat.label) : navbarTranslation("Messages")}
      active={activeNavBar === "chat"}
      path={TAB_BY_ID.chat.route}
      icon={TAB_BY_ID.chat.icon}
      count={hasFeature && !navBarHidden ? selectedItineraryUnreadCount : undefined}
    />
  );
};

// The only lock on this item; the disabled-tab store is not read here as well.
const FeatureChatItem = withFeaturePermission(ChatItem, {
  requiredFeature: "Chat",
});
